export enum Status {
  APPLICATION_STARTED = 'Application started',
  AUTOMATED_FIRST_CONTACT = 'Automated first contact',
  AWAITING_RESPONSE = 'Awaiting response',
  BOOKED = 'Booked',
  DENIED = 'Denied',
  FOLLOW_UP = 'Follow up',
  NEEDS_ACTION = 'Needs action',
  NEW = 'New',
  NOT_INTERESTED = 'Not interested',
  ON_HOLD = 'On hold',
  PENDING = 'Pending',
  REENGAGED = 'Reengaged',
  WORKING = 'Working',
}

interface PotentialBooking {
  beginningMoveInDate: string | null
  beginningMoveOutDate: string | null
  createdAt: string
  displayCity: string | null
  endingMoveInDate: string | null
  endingMoveOutDate: string | null
  id: number
  status: Status
}

export interface PotentialBookingListRow extends PotentialBooking {
  follupDate: string | null
  lead: Lead
}

interface Lead {
  email: string | null
  fullName: String
  id: number
  phone: string | null
}
